<template>
  <v-btn
    rounded
    size="small"
    :variant="text ? 'text' : undefined"
    :disabled="disabled"
    class="small-button text-transform-initial p14 p14-sb"
    :class="getClass()"
  >
    <slot />
  </v-btn>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'SmallButton',
    props: {
      disabled: Boolean,
      brown: Boolean,
      text: Boolean,
    },
    methods: {
      getClass() {
        if (this.text) {
          return 'bg-none';
        }
        if (this.brown) {
          return 'brown-button';
        } else {
          return 'white-button';
        }
      },
    },
  });
</script>

<style lang="scss">
  .small-button {
    padding: 2px 24px !important;
    margin: 8px;
  }

  .bg-none {
    background: none !important;
  }

  .brown-button {
    background-color: $brownColor !important;
    color: $whiteColor !important;
  }

  .white-button {
    color: $brownColor !important;
    background-color: $whiteColor !important;
  }
</style>
